import React, {useEffect, useMemo, useRef} from 'react';
import Chart from 'chart.js/auto';
import {Move} from "../../model/Move";

interface RadarChartDertigenProps {
    lobbyMoves: Move[];
}

interface PlayerMetrics {
    player: string;
    drinkTurns: number;
    avgDrunkPerDrinkTurn: number;
}

const RadarChartDertigen: React.FC<RadarChartDertigenProps> = ({lobbyMoves}) => {
    const chartRef = useRef<HTMLCanvasElement>(null);

    const playerMetrics = useMemo(() => {
        const grouped: Record<string, {
            player: string;
            drinkTurns: number;
            turnMoves: number;
            doublers: number;
            drankDuringDrinkTurns: number;
        }> = {};

        console.log(lobbyMoves)

        lobbyMoves.forEach((move) => {
            const player = move.player;

            if (!grouped[player]) {
                grouped[player] = {
                    player,
                    drinkTurns: 0,
                    turnMoves: 0,
                    doublers: 0,
                    drankDuringDrinkTurns: 0,
                };
            }

            if (move.turnMove === false) {
                grouped[player].drinkTurns += 1;
                grouped[player].drankDuringDrinkTurns += Math.max(0, move.gulps);
            }

            if (move.turnMove === true) {
                grouped[player].turnMoves += 1;
            }

            if (move.doubler) {
                grouped[player].doublers += 1;
            }
        });

        return Object.values(grouped)
            .map((item): PlayerMetrics => {
                const avgDrunkPerDrinkTurn =
                    item.drinkTurns > 0 ? item.drankDuringDrinkTurns / item.drinkTurns : 0;


                return {
                    player: item.player,
                    drinkTurns: item.drinkTurns,
                    avgDrunkPerDrinkTurn,
                };
            })
            .sort((a, b) => b.drinkTurns - a.drinkTurns);
    }, [lobbyMoves]);

    useEffect(() => {
        const ctx = chartRef.current?.getContext('2d');
        if (!ctx || playerMetrics.length === 0) {
            return;
        }

        const labels = playerMetrics.map((item) => item.player);
        const avgDrunkData = playerMetrics.map((item) => Number(item.avgDrunkPerDrinkTurn.toFixed(2)));
        const drinkTurnsData = playerMetrics.map((item) => item.drinkTurns);

        const chart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels,
                datasets: [
                    {
                        label: 'Gem. gedronken / drinkbeurt',
                        data: avgDrunkData,
                        backgroundColor: 'rgba(122, 162, 247, 0.75)',
                        borderColor: 'rgba(122, 162, 247, 1)',
                        borderWidth: 1,
                    },
                    {
                        label: 'Aantal drinkbeurten',
                        data: drinkTurnsData,
                        backgroundColor: 'rgba(158, 206, 106, 0.75)',
                        borderColor: 'rgba(158, 206, 106, 1)',
                        borderWidth: 1,
                    },
                ],
            },
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                plugins: {
                    legend: {
                        labels: {
                            color: '#d4d9e2',
                            boxWidth: 10,
                            boxHeight: 10,
                            font: {
                                size: 11,
                            },
                        },
                    },
                    tooltip: {
                        backgroundColor: '#141821',
                        titleColor: '#f5f7fb',
                        bodyColor: '#e3e8f0',
                        borderColor: 'rgba(255,255,255,0.16)',
                        borderWidth: 1,
                        callbacks: {
                            label: (context) => {
                                const value = context.raw as number;

                                if (context.datasetIndex === 0) {
                                    return `${context.dataset.label}: ${value.toFixed(2)} slokken/beurt`;
                                }

                                if (context.datasetIndex === 1) {
                                    return `${context.dataset.label}: ${Math.round(value)}`;
                                }

                                return `${context.dataset.label}: ${value.toFixed(1)}%`;
                            },
                        },
                    },
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        ticks: {
                            color: '#b8c0cb',
                        },
                        grid: {
                            color: 'rgba(255,255,255,0.1)',
                        },
                    },
                    y: {
                        ticks: {
                            color: '#b8c0cb',
                            font: {
                                size: 11,
                            },
                        },
                        grid: {
                            display: false,
                        },
                    },
                },
            },
        });

        return () => {
            chart.destroy();
        };
    }, [playerMetrics]);

    if (playerMetrics.length === 0) {
        return <p className="dashboard-empty-note">Nog onvoldoende data voor het spelersprofiel.</p>;
    }

    return <canvas ref={chartRef}/>;
};

export default RadarChartDertigen;
